export default {
  name: 'codeBlock',
  type: 'button',
  icon: 'ios-code',
  description: '代码块',
  handleToolbar: (quill) => {
    quill.format('code-block', true)
  }
}



// WEBPACK FOOTER //
// ./src/components/quill/toolbar/code-block.js